<div class="relative flex size-full min-h-screen flex-col">
  <app-header></app-header>

  <main class="w-full flex-1 px-6 pt-6">
    <router-outlet></router-outlet>
  </main>
</div>
